module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("aGQCp"))).then(() => parcelRequire('1iHdE'));